export default __webpack_public_path__ + "static/media/CNo.75-1.481fec13.jpg";